import { z } from 'zod';
import { emailSchema } from '../common/email.js';
import { firstNameSchema } from '../common/first-name.js';
import { lastNameSchema } from '../common/last-name.js';
import { countryCodeSchema, phoneNumberSchema, validatePhone } from '../common/phone-number.js';
export const inquiryBuyPropertyInterestEnum = {
    PRIMARY_RESIDENCE: 'Primary Residence',
    INVESTMENT_PROPERTY: 'Investment Property',
    VACATION_HOME: 'Vacation Home',
};
export const inquiryBuyPropertySchema = z
    .object({
    first_name: firstNameSchema,
    last_name: lastNameSchema,
    email: emailSchema,
    phone_number: phoneNumberSchema,
    phone_number_country_code: countryCodeSchema,
    buying_interest: z.enum(inquiryBuyPropertyInterestEnum).meta({ field: 'select' }),
    market: z.string().meta({
        field: 'select',
        optionsApi: '/markets?active=true',
        optionsApiCallback: (value) => `${value.city}, ${value.state}`,
    }),
})
    .superRefine((data, ctx) => {
    validatePhone(ctx, 'phone_number', data.phone_number, data.phone_number_country_code);
});
